import React from 'react';
import '../styles/App.css';
import '../styles/Table.css'

/**
 * Class used for rendering the calibration data for GSPAS Vehicles
 *
 * @author Ethan Jones
 */
class GspasCalibrationTable extends React.Component {

    /**
     * Method used for rendering Gspas Calibration information
     * @returns {*}
     */
    renderGspasCalibrationTable() {
        const { stepDescriptions, stepCalData, progSeqData } = this.props;

        if (!Array.isArray(stepDescriptions) || !stepCalData || !progSeqData) {
            return null;
        }

        return (
            stepDescriptions.map((key, index) => (
                <div className={"GspasCalibrationTableContainer"} key={index}>
                    <label className={"GspasCalTableLabel"}>
                        {key}
                    </label>
                    <table className={"GspasCalibrationTable"}>
                        <thead>
                        <tr>
                            <th>Controller</th>
                            <th>Module Id</th>
                            <th>CVN</th>
                            <th>Selected Software</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Array.isArray(stepCalData[key]) && stepCalData[key].map((data, index) => (
                            <tr key={index}>
                                <td>{data[2]}</td>
                                <td>{data[1]}</td>
                                <td>{progSeqData.cvnMap && progSeqData.cvnMap[data[0]]}</td>
                                <td>{data[0]}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            ))
        );
    }

    /**
     * Main render method for GspasCalibrationMethod
     * @returns {*}
     */
    render() {

        return (this.renderGspasCalibrationTable())
    }

}

export default GspasCalibrationTable;